import { AlertTriangle } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const isBatchFull = (e) => e?.response?.status === 409 && e?.response?.data?.detail?.code === "BATCH_FULL";

export function BatchFullDialog({ info, onClose }) {
  if (!info) return null;
  return (
    <AlertDialog open onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="batch-full-dialog" className="max-w-sm">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display flex items-center gap-2 text-red-700"><AlertTriangle className="w-5 h-5" /> Batch Full</AlertDialogTitle>
          <AlertDialogDescription data-testid="batch-full-message" className="text-slate-700">
            {info.message || "Batch capacity has been Full. Please choose another one."}
            {info.capacity != null && <span className="block mt-2 text-xs text-slate-500">This batch already has {info.enrolled} of {info.capacity} candidates.</span>}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter><AlertDialogAction data-testid="batch-full-ok" onClick={onClose} className="rounded-xl bg-emerald-700 hover:bg-emerald-800">Choose another batch</AlertDialogAction></AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
